import React, {
    useEffect,
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import {
    useHistory,
    useParams,
} from "react-router-dom";

import {
    FiActivity,
    FiArrowLeft,
    FiBriefcase,
    FiCalendar,
    FiCheckCircle,
    FiCode,
    FiGlobe,
    FiInfo,
    FiRefreshCw,
    FiShield,
    FiUser,
    FiXCircle,
} from "react-icons/fi";

import {
    fetchPlatformActivityById,
    clearSelectedPlatformActivity,

    selectSelectedPlatformActivity,
    selectPlatformActivityDetailsLoading,
    selectPlatformActivityDetailsError,
} from "../../../../../store/platformActivity/platformActivitySlice";

import "./PlatformActivity.css";


/*
|--------------------------------------------------------------------------
| FORMAT DATE
|--------------------------------------------------------------------------
*/

const formatDate = (
    value
) => {

    if (
        !value
    ) {

        return "-";

    }


    const date =
        new Date(
            value
        );


    if (
        Number.isNaN(
            date.getTime()
        )
    ) {

        return "-";

    }


    return date.toLocaleString(
        "en-IN",
        {
            day:
                "2-digit",

            month:
                "short",

            year:
                "numeric",

            hour:
                "2-digit",

            minute:
                "2-digit",

            second:
                "2-digit",
        }
    );

};


/*
|--------------------------------------------------------------------------
| FORMAT LABEL
|--------------------------------------------------------------------------
*/

const formatLabel = (
    value
) => {

    return String(
        value ||
        ""
    )
        .replace(
            /_/g,
            " "
        )
        .toLowerCase()
        .replace(
            /\b\w/g,
            (
                letter
            ) =>
                letter.toUpperCase()
        );

};


/*
|--------------------------------------------------------------------------
| JSON BLOCK
|--------------------------------------------------------------------------
*/

const JsonBlock = ({
    title,
    value,
}) => {

    if (
        value === undefined ||
        value === null
    ) {

        return null;

    }


    return (

        <section className="platform-activity-json-card">

            <div className="platform-activity-json-header">

                <FiCode />

                <strong>

                    {
                        title
                    }

                </strong>

            </div>


            <pre>

                {
                    JSON.stringify(
                        value,
                        null,
                        2
                    )
                }

            </pre>

        </section>

    );

};


/*
|--------------------------------------------------------------------------
| DETAIL ITEM
|--------------------------------------------------------------------------
*/

const DetailItem = ({
    icon: Icon,
    label,
    value,
    children,
}) => {

    return (

        <div className="platform-activity-detail-item">

            <div className="platform-activity-detail-icon">

                {
                    Icon
                        ? <Icon />
                        : null
                }

            </div>


            <div className="platform-activity-detail-content">

                <span>

                    {
                        label
                    }

                </span>


                {
                    children
                        ? children
                        : (

                            <strong>

                                {
                                    value ||
                                    "-"
                                }

                            </strong>

                        )
                }

            </div>

        </div>

    );

};


/*
|--------------------------------------------------------------------------
| PLATFORM ACTIVITY DETAILS
|--------------------------------------------------------------------------
*/

const PlatformActivityDetails =
    () => {

        const dispatch =
            useDispatch();


        const history =
            useHistory();


        const {
            id,
        } =
            useParams();


        /*
        |--------------------------------------------------------------------------
        | REDUX
        |--------------------------------------------------------------------------
        */

        const activity =
            useSelector(
                selectSelectedPlatformActivity
            );


        const loading =
            useSelector(
                selectPlatformActivityDetailsLoading
            );


        const error =
            useSelector(
                selectPlatformActivityDetailsError
            );


        /*
        |--------------------------------------------------------------------------
        | LOAD
        |--------------------------------------------------------------------------
        */

        useEffect(
            () => {

                if (
                    id
                ) {

                    dispatch(
                        fetchPlatformActivityById(
                            id
                        )
                    );

                }


                return () => {

                    dispatch(
                        clearSelectedPlatformActivity()
                    );

                };

            },
            [
                dispatch,
                id,
            ]
        );


        /*
        |--------------------------------------------------------------------------
        | REFRESH
        |--------------------------------------------------------------------------
        */

        const handleRefresh =
            () => {

                if (
                    !id
                ) {

                    return;

                }


                dispatch(
                    fetchPlatformActivityById(
                        id
                    )
                );

            };


        /*
        |--------------------------------------------------------------------------
        | DERIVED
        |--------------------------------------------------------------------------
        */

        const resultStatus =
            String(
                activity?.status ||
                ""
            )
                .trim()
                .toUpperCase();


        const isFailed =
            resultStatus ===
            "FAILED";


        const platformAdmin =
            activity?.platformAdminId &&
            typeof activity.platformAdminId ===
                "object"
                ? activity.platformAdminId
                : null;


        const tenant =
            activity?.tenantId &&
            typeof activity.tenantId ===
                "object"
                ? activity.tenantId
                : null;


        /*
        |--------------------------------------------------------------------------
        | LOADING
        |--------------------------------------------------------------------------
        */

        if (
            loading &&
            !activity
        ) {

            return (


                    <div className="platform-activity-details-state">

                        <div className="platform-activity-loader" />


                        <strong>

                            Loading Activity

                        </strong>


                        <span>

                            Fetching platform audit information...

                        </span>

                    </div>


            );

        }


        /*
        |--------------------------------------------------------------------------
        | NOT FOUND
        |--------------------------------------------------------------------------
        */

        if (
            !activity &&
            !loading
        ) {

            return (


                    <div className="platform-activity-details-state">

                        <FiActivity />


                        <h2>

                            Activity Not Found

                        </h2>


                        <p>

                            {
                                error?.message ||
                                "The requested platform activity could not be loaded."
                            }

                        </p>


                        <button
                            type="button"
                            onClick={() =>
                                history.push(
                                    "/platform/activity"
                                )
                            }
                        >

                            <FiArrowLeft />

                            Back to Activity

                        </button>

                    </div>


            );

        }


        /*
        |--------------------------------------------------------------------------
        | UI
        |--------------------------------------------------------------------------
        */

        return (


                <div className="platform-activity-details-page">

                    {/*
                    |--------------------------------------------------------------------------
                    | HEADER
                    |--------------------------------------------------------------------------
                    */}

                    <header className="platform-activity-details-header">

                        <div>

                            <button
                                type="button"
                                className="platform-activity-back"
                                onClick={() =>
                                    history.push(
                                        "/platform/activity"
                                    )
                                }
                            >

                                <FiArrowLeft />

                                Platform Activity

                            </button>


                            <div className="platform-activity-details-title-row">

                                <div className="platform-activity-details-icon">

                                    <FiActivity />

                                </div>


                                <div>

                                    <div className="platform-activity-details-title">

                                        <h1>

                                            {
                                                formatLabel(
                                                    activity?.action
                                                )
                                            }

                                        </h1>


                                        <span
                                            className={`platform-activity-result ${
                                                isFailed
                                                    ? "failed"
                                                    : "success"
                                            }`}
                                        >

                                            {
                                                isFailed
                                                    ? <FiXCircle />
                                                    : <FiCheckCircle />
                                            }

                                            {
                                                resultStatus ||
                                                "SUCCESS"
                                            }

                                        </span>

                                    </div>


                                    <p>

                                        {
                                            activity?.description ||
                                            "Platform audit record"
                                        }

                                    </p>

                                </div>

                            </div>

                        </div>


                        <button
                            type="button"
                            className="platform-activity-refresh"
                            onClick={
                                handleRefresh
                            }
                            disabled={
                                loading
                            }
                        >

                            <FiRefreshCw
                                className={
                                    loading
                                        ? "platform-activity-spin"
                                        : ""
                                }
                            />

                            Refresh

                        </button>

                    </header>


                    {/*
                    |--------------------------------------------------------------------------
                    | OVERVIEW
                    |--------------------------------------------------------------------------
                    */}

                    <section className="platform-activity-details-overview">

                        <article>

                            <span>
                                Action
                            </span>

                            <strong>

                                {
                                    formatLabel(
                                        activity?.action
                                    )
                                }

                            </strong>

                        </article>


                        <article>

                            <span>
                                Entity Type
                            </span>

                            <strong>

                                {
                                    formatLabel(
                                        activity?.entityType
                                    )
                                }

                            </strong>

                        </article>


                        <article>

                            <span>
                                Result
                            </span>

                            <strong>

                                {
                                    resultStatus ||
                                    "-"
                                }

                            </strong>

                        </article>


                        <article>

                            <span>
                                Created
                            </span>

                            <strong>

                                {
                                    formatDate(
                                        activity?.createdAt
                                    )
                                }

                            </strong>

                        </article>

                    </section>


                    {/*
                    |--------------------------------------------------------------------------
                    | DETAILS GRID
                    |--------------------------------------------------------------------------
                    */}

                    <div className="platform-activity-details-grid">

                        {/*
                        |--------------------------------------------------------------------------
                        | ACTOR
                        |--------------------------------------------------------------------------
                        */}

                        <section className="platform-activity-details-card">

                            <div className="platform-activity-details-card-header">

                                <div>
                                    <FiShield />
                                </div>


                                <div>

                                    <h2>
                                        Platform Administrator
                                    </h2>

                                    <p>
                                        Super Admin who performed this action.
                                    </p>

                                </div>

                            </div>


                            <div className="platform-activity-detail-list">

                                <DetailItem
                                    icon={
                                        FiUser
                                    }
                                    label="Name"
                                    value={
                                        activity?.actorName ||
                                        platformAdmin?.name
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiInfo
                                    }
                                    label="Email"
                                    value={
                                        activity?.actorEmail ||
                                        platformAdmin?.email
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiShield
                                    }
                                    label="Role"
                                    value={
                                        platformAdmin?.role
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCheckCircle
                                    }
                                    label="Current Status"
                                    value={
                                        platformAdmin?.status
                                    }
                                />

                            </div>

                        </section>


                        {/*
                        |--------------------------------------------------------------------------
                        | BUSINESS
                        |--------------------------------------------------------------------------
                        */}

                        <section className="platform-activity-details-card">

                            <div className="platform-activity-details-card-header">

                                <div>
                                    <FiBriefcase />
                                </div>


                                <div>

                                    <h2>
                                        Business
                                    </h2>

                                    <p>
                                        Tenant associated with this activity.
                                    </p>

                                </div>

                            </div>


                            <div className="platform-activity-detail-list">

                                <DetailItem
                                    icon={
                                        FiBriefcase
                                    }
                                    label="Business Name"
                                    value={
                                        activity?.tenantName ||
                                        tenant?.name
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCode
                                    }
                                    label="Business Code"
                                    value={
                                        activity?.tenantCode ||
                                        tenant?.code
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCheckCircle
                                    }
                                    label="Business Status"
                                    value={
                                        tenant?.status
                                    }
                                />

                            </div>

                        </section>


                        {/*
                        |--------------------------------------------------------------------------
                        | ENTITY
                        |--------------------------------------------------------------------------
                        */}

                        <section className="platform-activity-details-card">

                            <div className="platform-activity-details-card-header">

                                <div>
                                    <FiActivity />
                                </div>


                                <div>

                                    <h2>
                                        Entity
                                    </h2>

                                    <p>
                                        Target resource affected by the action.
                                    </p>

                                </div>

                            </div>


                            <div className="platform-activity-detail-list">

                                <DetailItem
                                    icon={
                                        FiActivity
                                    }
                                    label="Entity Type"
                                    value={
                                        formatLabel(
                                            activity?.entityType
                                        )
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiUser
                                    }
                                    label="Entity Name"
                                    value={
                                        activity?.entityName
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCode
                                    }
                                    label="Entity ID"
                                    value={
                                        activity?.entityId
                                    }
                                />

                            </div>

                        </section>


                        {/*
                        |--------------------------------------------------------------------------
                        | REQUEST
                        |--------------------------------------------------------------------------
                        */}

                        <section className="platform-activity-details-card">

                            <div className="platform-activity-details-card-header">

                                <div>
                                    <FiGlobe />
                                </div>


                                <div>

                                    <h2>
                                        Request Information
                                    </h2>

                                    <p>
                                        Request context captured during the platform action.
                                    </p>

                                </div>

                            </div>


                            <div className="platform-activity-detail-list">

                                <DetailItem
                                    icon={
                                        FiGlobe
                                    }
                                    label="IP Address"
                                    value={
                                        activity?.ipAddress
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCode
                                    }
                                    label="HTTP Method"
                                    value={
                                        activity?.requestMethod
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiGlobe
                                    }
                                    label="Request Path"
                                    value={
                                        activity?.requestPath
                                    }
                                />


                                <DetailItem
                                    icon={
                                        FiCalendar
                                    }
                                    label="Date / Time"
                                    value={
                                        formatDate(
                                            activity?.createdAt
                                        )
                                    }
                                />

                            </div>

                        </section>


                        {/*
                        |--------------------------------------------------------------------------
                        | USER AGENT
                        |--------------------------------------------------------------------------
                        */}

                        <section className="platform-activity-details-card platform-activity-details-wide">

                            <div className="platform-activity-details-card-header">

                                <div>
                                    <FiGlobe />
                                </div>


                                <div>

                                    <h2>
                                        User Agent
                                    </h2>

                                    <p>
                                        Browser or client information captured from the request.
                                    </p>

                                </div>

                            </div>


                            <div className="platform-activity-user-agent">

                                {
                                    activity?.userAgent ||
                                    "No user agent captured."
                                }

                            </div>

                        </section>


                        {/*
                        |--------------------------------------------------------------------------
                        | ERROR
                        |--------------------------------------------------------------------------
                        */}

                        {isFailed ? (

                            <section className="platform-activity-details-card platform-activity-details-wide platform-activity-error-card">

                                <div className="platform-activity-details-card-header">

                                    <div>
                                        <FiXCircle />
                                    </div>


                                    <div>

                                        <h2>
                                            Error Information
                                        </h2>

                                        <p>
                                            Failure information captured for this platform operation.
                                        </p>

                                    </div>

                                </div>


                                <div className="platform-activity-error-message">

                                    {
                                        activity?.errorMessage ||
                                        "No error message recorded."
                                    }

                                </div>

                            </section>

                        ) : null}

                    </div>


                    {/*
                    |--------------------------------------------------------------------------
                    | JSON DATA
                    |--------------------------------------------------------------------------
                    */}

                    <div className="platform-activity-json-grid">

                        <JsonBlock
                            title="Previous Value"
                            value={
                                activity?.oldValue
                            }
                        />


                        <JsonBlock
                            title="New Value"
                            value={
                                activity?.newValue
                            }
                        />


                        <JsonBlock
                            title="Metadata"
                            value={
                                activity?.metadata
                            }
                        />

                    </div>

                </div>


        );

    };


export default PlatformActivityDetails;